import {Component} from '@angular/core';
import {CarouselModel} from "../../../models/carousel.model";
import {GameService} from "../../../services/game.service";
import {Subscription} from "rxjs";
import {CarouselBuilderService} from "../../../services/carousel-builder.service";
import {Publisher} from "../../../models/publisher.class";


declare var bootstrap: any;


@Component({
  selector: 'app-providers-carousel',
  templateUrl: './providers-carousel.component.html',
  styleUrls: ['./providers-carousel.component.scss']
})
export class ProvidersCarouselComponent {

  providers: Publisher[] = [];
  providerSubs: Subscription;

  currentSlideIndex: number = 0;

  numOfSlides: number;
  carousels: CarouselModel[] = [];

  constructor(
    private carouselService: CarouselBuilderService,
    private gameService: GameService,
  ) {
    this.numOfSlides = this.carouselService.numOfSlides;

    this.providerSubs = this.gameService.providers$.subscribe(p => {
      // we filter publishers that have games
      this.providers = p.filter(p => p.gameList && p.gameList.length)
      //fallback for publishers not having games in BS - when user is logged in, no games from API/cached in LS, we have publishers from cdn/cached
      if (!this.providers.length){
        this.providers = this.gameService.providers; //=use providers without games
      }
      // console.log(this.providers)

      this.currentSlideIndex = 0;
      this.carousels = this.carouselService.buildCarousels(this.providers);
      // console.log(this.carousels)
    })
  }


  moveSlide(direction: 'prev' | 'next', size: string) {
    let carouselId = `carousel${size}PROVIDERS`;
    let myCarousel = document.getElementById(carouselId);

    if (myCarousel) {
      const bsCarousel = new bootstrap.Carousel(myCarousel);
      this.currentSlideIndex = direction === 'prev' ? this.currentSlideIndex - 1 : this.currentSlideIndex + 1;

      direction === 'next' ? bsCarousel.next() : bsCarousel.prev();
    }
  }

  //use placeholder when the image is not found
  updateNotFoundImgUrl(event: Event) {
    (event.target as HTMLImageElement).src = this.generateProviderSvgPlaceholderUrl((event.target as HTMLImageElement).alt.split(" ")[0]);
  }

  generateProviderSvgPlaceholderUrl(text: string): string {
    const svg = `
    <svg width="300" height="150" xmlns="http://www.w3.org/2000/svg">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center;color:#fff;font-size:50px;font-weight:bold;line-height:1.2;font-family:sans-serif;">${text}</div>
      </foreignObject>
    </svg>
  `;
    return `data:image/svg+xml;base64,${btoa(svg)}`;
  }

  ngOnDestroy(){
    this.providerSubs.unsubscribe();
  }



}
